import * as React from 'react';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { react: React, "@mui/material/TextField": TextField, "@mui/material/Autocomplete": Autocomplete, "@mui/icons-material/CheckBoxOutlineBlank": CheckBoxOutlineBlankIcon, "@mui/icons-material/CheckBox": CheckBoxIcon } } });
export default ClientProvider;
